// src/components/tools/MeasureToolPanel.jsx
//
// Horizontal pill anchored next to the measure rail button. Height matches
// the rail button (~29px). Content is computed by `deriveSlideoutContent`
// (sibling file) — when that returns null, the parent (CommandRail) skips
// rendering this component entirely, so there is no internal "should I
// render" branch here.

import { X } from "lucide-react";

export default function MeasureToolPanel({ content, onClear }) {
  return (
    <div
      className="h-[29px] flex items-center gap-2 px-2.5
                 rounded-sm border border-accent-info/60 bg-white/95
                 shadow-md text-slate-700"
    >
      <span className="text-[11px] font-medium tabular-nums whitespace-nowrap">
        {content}
      </span>
      <button
        type="button"
        onClick={onClear}
        title="Clear measurement"
        className="text-slate-500 hover:text-slate-900 transition"
      >
        <X size={13} />
      </button>
    </div>
  );
}
